import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, CardHeader, Button,Col, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter,Row } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Form from 'react-bootstrap/Form';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';

/////COMPONENTE DE  FORMATEAR FECHA/////
import Moment from "moment";
////COMPONENTE PARA FECHA  DatePicker/////
import DatePicker, { registerLocale } from "react-datepicker";
import InputMask from 'react-input-mask';
import { es } from "date-fns/locale";
import * as moment from 'moment';
import Venta from '../Ventas/Venta';


registerLocale("es", es);

const modeloDatos = {
    citaID: 0,
    empresaID: 1,
    nombrePaciente: "",
    telefono: "",
    tratamientoID: 1,
    nombreTratamiento: "",
    fecha: new Date(),
    hora: "08:00:00",
    especialistaID: 1,
    nombreEspecialista: "",
    comentario: "",
    confirmacionCita: false,
    notificacionCorreo: false,
    notificacionWhatsapp: false,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date(),
    fechaModificado: new Date(),
    eliminado:false,
    facturado: false,
    edad: 0,
    cedula:"",
    seguroID: 1,
    nombreSeguro: "",
    sucursalID: 1,
    sucursal: "",domicilio:""

 
}
let optionsSeguro = [];
let optionsArticulos = [];
let optionsDoctores = [];

///// USESTATE DE FECHA (VARIABLE PARA MANEJAR LA FECHA) ////
let FechaControl = new Date();
const Version = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [ListadoCitas, SetListadoCitas] = useState([]);
    const [ListadoSucursal, SetListadoSucursal] = useState([]);
    const [ListadoCitasH, SetListadoCitasH] = useState([]);
    const [ListaEsp, SetListaEsp] = useState([]);
    const [ListaProd, SetListaProd] = useState([]);
    const [interativo, Setinterativo] = useState(false);
    const [HistorialCita, SetHistorialCita] = useState(false);
    const [Listado, SetListado] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [busqueda, setbusqueda] = useState("");
    const [contador, setContador] = useState(0);

    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [pendiente, setPendiente] = useState(true);
    const [verModalCita, setVerModalCita] = useState(false);
    const [VerFactura, setVerFactura] = useState(false);
    const [Visualizar, setVisualizar] = useState(false);
    const [VisualizarC, setVisualizarC] = useState(false);
    const [Fac, setFac] = useState([]);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [ListaDoctores, SetListadoDoctor] = useState([]);
    const [ListaHorario, SetListadoHorario] = useState([]);

    const [key, setKey] = useState(0);


    const apagarcomponente = (e) => {
        setVerFactura(e);
    };

    const handleChangef = (e) => {
        setTabla({
            ...tabla,
            "fecha": e
        })
        obtenerDatosHorario(tabla.especialistaID)
    }
    const handleChange = (e) => {
      


      // let value = e.target.nodeName === "SELECT" ? (e.target.name == "notificacionWhatsapp" ? true : false) : e.target.value;

        const { name, value } = e.target;

        switch (name) {
            case "telefono": {
                // opcional: solo dígitos
                // const v = value.replace(/\D/g, "");
                setTabla((p) => ({ ...p, telefono: value }));
                if (value.length === 10) {
                    BuscarPorTelefono(value);
                }
                break;
            }

            case "cedula": {
                // En RD normalmente son 11 dígitos
                setTabla((p) => ({ ...p, cedula: value }));
                if (value.length >= 11) {
                    ValidarCedula(value);
                }
                break;
            }

            case "especialistaID": {
                setTabla((p) => ({ ...p, especialistaID: value }));
                obtenerDatosHorario(value);
                break;
            }

            case "sucursalID": {
                const sucursal =
                    ListadoSucursal.find(
                        (x) => String(x.sucursalID) === String(value)
                    )?.descripcion || "";
                setTabla((p) => ({ ...p, sucursalID: value, sucursal }));
                filtrarLunesMiercoles()
                break;
            }

            default: {
                setTabla((p) => ({ ...p, [name]: value }));
                break;
            }
        }

        //if (e.target.name == "telefono" && e.target.value.length == 10) {
        //    BuscarPorTelefono(e.target.value);
        //} else {
        //    if (e.target.name == "cedula" && e.target.value.length > 10) {
        //        ValidarCedula(e.target.value);
        //    }
        //    else {
        //setTabla({
        //    ...tabla,
        //    [e.target.name]: e.target.value
        //})
        //    if (e.target.name == "especialistaID") {
        //        obtenerDatosHorario(e.target.value)
        //    }
          
        //}
        //}
        //if (e.target.name == "sucursalID") {
        //    var sucursal = ListadoSucursal.find(x => x.sucursalID == e.target.value)?.descripcion;
        //    setTabla({
        //        ...tabla,
        //        "sucursalID": e.target.value, "sucursal": sucursal
        //    })
        //}
    }

    const obtenerDatosSucursal = async () => {
        let response = await fetch(Api + "Administracion/listaSucursal/0");
        if (response.ok) {
            let data = await response.json()
            SetListadoSucursal(data)
             }
    }

    const ValidarCedula = async (x) => {

    //    var nomb = Listado.filter(e => e.cedula == x).map(d => d);
    //    tabla.nombrePaciente = nomb.nombrePaciente;
    //   // tabla.cedula = nomb.cedula;
    //    tabla.edad = nomb.edad;
    //    tabla.seguroID = nomb.seguroID;
    //    tabla.nombreSeguro = nomb.nombreSeguro;
    
   
       
            let response1 = await fetch(Api + "administracion/ConsultaCed/" + x);
        if (response1.ok) {
            let data1 = await response1.json()


            if (data1 != false) {
                var eda = calcularEdad((data1[0]).fechaNacimiento, new Date())
                setTabla({
                    ...tabla, nombrePaciente: (data1[0]).nombres + " " + (data1[0]).apellido1 + " " + (data1[0]).apellido2, cedula: x,
                    edad: eda
                })
            }
        } else {
            setTabla({
                ...tabla,
                'cedula': x
            })
        }
    }

    function calcularEdad(fechaNacimiento, fechaActual) {
        var nacimiento = new Date(fechaNacimiento);
        var actual = new Date(fechaActual);

        var edad = actual.getFullYear() - nacimiento.getFullYear();
        var mes = actual.getMonth() - nacimiento.getMonth();
        var dia = actual.getDate() - nacimiento.getDate();

        // Ajustar si el mes o el día no ha pasado aún este año
        if (mes < 0 || (mes === 0 && dia < 0)) {
            edad--;
        }

        return edad;
    }

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);

        var searchData = l.filter((item) => {
            if (
                (item.telefono + item.nombrePaciente + item.fecha)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

    let correo = JSON.parse(user).correo;
    let rol = JSON.parse(user).idRol;
    let EmpresaID = JSON.parse(user).empresaID;
    /////Buuscar por telefono
    const BuscarPorTelefono = async (t) => {
        let response = await fetch(Api + "Citas/BuscarNombre/" + t + "/" + correo);
        if (response.ok) {
            let data = await response.json()
            tabla.nombrePaciente = data.nombrePaciente;
            tabla.cedula = data.cedula;
            tabla.edad = data.edad;
            tabla.seguroID = data.seguroID;
            tabla.nombreSeguro = data.nombreSeguro;
        }
        setTabla({
            ...tabla,
            'telefono': t
        })
    }

    const Cam_F = (x) => {
        setFechaInicio(x)
        FechaControl = x;
        obtenerDatosCitas(x)
        setPendiente(true)
    }

    const cantador = () => {
        
        //setTimeout(function (e) {
        //    obtenerDatosCitas(FechaControl)
        //    cantador();
           
        //},10000)
       
    }

    /////// Ejemplo de como Formatear fecha
    /////// Moment(fechaInicio).format('YYYY-MM-DD')

    const obtenerDatosCitas = async (x) => {
        let response = await fetch(Api + "Citas/ListaCitas/" + Moment(x).format('YYYY-MM-DD') + "/" + correo);
        if (response.ok) {
            let data = await response.json()
          
          
            SetListadoCitas(data)
            setPendiente(false)
        }
    }
    const obtenerDatosCitasH = async (x) => {
        let response = await fetch(Api + "Citas/ListaCitasH/" + correo);
        if (response.ok) {
            let data = await response.json()
         
            SetListado1(data)
            if (pendiente) {
                SetListado(data)
                setPendiente(false)
            }
        }
    }
    const obtenerDatosW = async () => {
        let response = await fetch(Api + "administracion/ListaEmpresas/"+JSON.parse(user).empresaID);
        if (response.ok) {
            let data = await response.json()
            setFac(data);
        }

        //let response1 = fetch(Api + `administracion/ListaEmpresas?id=${JSON.parse(user).empresaID}`).then((response) => {
        //    return response.ok ? response.json() : Promise.reject(response);
        //}).then((dataJson) => {
        //    var data1 = dataJson;
        //    setFac(data1);
        //})
    }
    const handleChange2 = (e) => {
        if (e.tab == "Seguro") {
            setTabla({
                ...tabla,
                ["seguroID"]: e.value, ["nombreSeguro"]: e.nombre
            })
        }    if (e.tab == "Doctor") {
            setTabla({
                ...tabla,
                ["especialistaID"]: e.value, ["nombreEspecialista"]: e.nombre
            })
        }    if (e.tab == "Servicio") {
            setTabla({
                ...tabla,
                ["tratamientoID"]: e.value, ["nombreTratamiento"]: e.nombre
            })
        } 
    }

    const obtenerespecialista = async () => {
        let response = await fetch(Api + "Citas/listaEspecialistas" + "/" + correo);
        if (response.ok) {
            let data = await response.json()
            SetListaEsp(data)
        }
    }

    const obtenerProductos = async () => {
        let response = await fetch(Api + "Citas/ListaProductos/"+correo);

        if (response.ok) {
            let data = await response.json()
            var d = data.filter(x => x.empresaID == EmpresaID).map(e => e)
            SetListaProd(d)

            if (d == 0) {

                const modeloDatosArt = {
                    articuloID: 0,
                    empresaID: EmpresaID + '',
                    descripcion: "Servicio Generico",
                    grupoArticulo: 0,
                    tipoArticulo: 0,
                    almacenPorDefecto: 1,
                    codigoAuxiliar: "",
                    costoPromedio: 1.00,
                    precioPromedio: 1.00,
                    unidadMedida: "",
                    creadoPor: correo,
                    modificadoPor: "",
                    fechaCreado: new Date,
                    fechaModificado: new Date,
                    cantidadMinima: 1,
                    cantidadMaxima: 1,
                    tiempoExpiracionMeses: 1,
                    tamano: "1",
                    activoFijo: "1",
                    ubicacionAlmacen: "1",
                    imagen: "",
                    activo: true,
                    cambiarDescripcion: false,
                    cambiarPrecio: false,
                    itbisIncluido: false,
                    margen: 1.00

                }

                let response1;
                response1 = await fetch(Api + "VentasMantenimiento/GuardarArticulos", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(modeloDatosArt)
                })
                if (response1.ok) {
                    let data2 = await response1.json()
                    d = [data2]
                } else {
                    Swal.fire(
                        'Atención!',
                        'Favor de Crear un Articulo.',
                        'warning'
                    )
                }
            }
            d.map(x => {
                optionsArticulos.push({ value: x.articuloID, label: x.descripcion, nombre: x.descripcion, tab: 'Servicio' })
            })
            tabla.tratamientoID = d[0].articuloID
        }
    }
    const ConfirmarCita = async (e) => {
        let response = await fetch(Api + "Citas/ConfirmarCita/"+e.citaID+"/"+correo+"/0");

        if (response.ok) {
            obtenerDatosCitas(FechaControl)
            toast.success("Proceso realizado")
        }
    }

    const obtenerDatosDoctor = async () => {
        let response = await fetch(Api + "CMantenimiento/listaDoctores/" + correo);

        if (response.ok) {
            let data = await response.json()
            var d = data.filter(x => x.empresaID == EmpresaID).map(e => e)
            SetListadoDoctor(d)
        
            if (d == 0) {
                const modeloDatos = {
                    doctorID: 0,
                    empresaID: JSON.parse(user).empresaID,
                    nombreDoctor: "Doctor General",
                    telefono: "",
                    especialidadID: 1,
                    creadoPor: JSON.parse(user).correo,
                    modificadoPor: "",
                    fechaCreado: new Date,
                    fechaModificado: new Date,
                    porcientoAcionista: 0.00,
                    porcientoReferido: 0.00,
                    porcientoTecnico: 0.00,
                    porcientoAyudante: 0.00

                }
                let response1;
                response1 = await fetch(Api + "CMantenimiento/GuardarDoctores", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(modeloDatos)
                })
                if (response1.ok) {
                    let data2 = await response1.json()
                    d = [data2]
                } else {
                    Swal.fire(
                        'Atención!',
                        'Favor de Crear un Doctor.',
                        'warning'
                    )
                }
            }
        }
        d.map(x => {
            optionsDoctores.push({ value: x.doctorID, label: x.nombreDoctor, nombre: x.nombreDoctor, tab: 'Doctor' })
        })
            tabla.especialistaID = d[0].doctorID
            obtenerDatosHorario(d[0].doctorID)
      
    }


    useEffect(() => {
        obtenerDatosCitas(FechaControl);
        const intervalo = setInterval(() => {
            setContador((prev) => prev + 1);
        }, 30000); // cada 2 segundos

        // Limpieza del intervalo cuando el componente se desmonta
        return () => clearInterval(intervalo); 
    }, [contador]);
    //}, [fechaInicio])

  

    useEffect(() => {
        obtenerDatosCitas(FechaControl);
        obtenerDatosW();;
        cantador();
        obtenerDatosDoctor()
        obtenerDatosSeguro()
        obtenerDatosCitasH()
        obtenerDatosSucursal()
    },[HistorialCita])

    const obtenerDatosHorario = async (e) => {
        let response = await fetch(Api + "Citas/ListaHorario/" + e + "/" +
            moment(tabla.fecha).format("YYYY-MM-DD"));

        if (response.ok) {
            let data = await response.json()
            SetListadoHorario(data)
        }
    }

    const EnviarWhatsAppM = async () => {
      //  obtenerDatosW();
        //     Buscar datos de whatsapp

        Swal.fire({
            title: 'WhatsApp Masivo Esta seguro?',
            text: "Desea Enviar Mensaje MASIVO Via WhatsApp",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
              

                ListadoCitas.map(x => {
                   if (x.notificacionWhatsapp == false) { 
                      
               let response = fetch(`https://graph.facebook.com/v17.0/${Fac.noWhatsapp}/messages`, {

                            method: 'POST',
                            headers: {
                                'Authorization': 'Bearer ' + Fac.tokenWhatsapp,
                                'Content-Type': 'application/json;charset=utf-8',

                            },
                      body: `{ \"messaging_product\": \"whatsapp\", \"to\": \"1${x.telefono}\", \"type\": \"template\", \"template\": { \"name\": \"${Fac.plantillaWhatsapp}\", \"language\": { \"code\": \"es_ES\" }, 
 "components": [
            {
                "type": "body",
                "parameters": [
                    {
                        "type": "text",
                        "text": "${x.nombrePaciente}"
                    } ,{
                        "type": "text",
                        "text": " ${moment(x.fecha).format("DD/MM/YYYY")} a las ${x.hora}, para confirmar su cita clic en la URL: http://tool.apatech.com.do/ConfirmacionCita/${x.citaID}/${x.telefono}"  
                    } ,{
                        "type": "text",
                        "text": "${x.comentario} ."
                    }
                ]
            }],
           } }`,
                       
                  // http://tool.apatech.com.do/ConfirmacionCita/1145/8297663936

                       
                     
                       //method: 'POST',
                   //     headers: {
                   //         'Authorization': 'Bearer '+Fac.tokenWhatsapp,
                   //         'Content-Type': 'application/json;charset=utf-8',                          
                   //     },
                   //     body: `{ \"messaging_product\": \"whatsapp\", \"to\": \"1${x.telefono}\", \"type\": \"template\", \"template\": { \"name\": \"${Fac.plantillaWhatsapp}\", \"language\": { \"code\": \"\" } } }`
                    })
                        Swal.fire(
                            'Enviado!',
                            'Los mensajes ha sido enviados.',
                            'success'
                        )

                    response = fetch(Api + "Citas/ValidarWhatsappCitas/" + x.citaID, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(tabla)
                    })
                       obtenerDatosCitas(FechaControl)

               }

                })
            }
        })
    }
    const RecordatorioWhatsapp = async (d) => {
   let response = fetch(Api + "Citas/ValidarWhatsappCitas/" + d, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(tabla)
   })
        obtenerDatosCitas(FechaControl)
    }

 
    const EnviarWhatsApp = async (d) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea Enviar Mensaje Via WhatsApp",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {


                let response =  fetch("https://graph.facebook.com/v15.0/111934941734793/messages", {


                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer EAAPLPiR8mBABAKJtIsj1lmVrZCNYgrLhaMCaE8rwWkgZB984NI6oTRy6YsjZBfeaOokMkt4jMJM2AiZCREFrhP6Ap3VgQyZBCVYdWJ5wrgaWOWhQpmhIOvO3v9JezeR3w2OFATvmR3SAIw7GZAxNz2CYWqvfZBYZC2vZAHPRbSEdc9dV3QoGAQKZAB35zSjwukqZBm2UODkv7GDnwZDZD',
                        'Content-Type': 'application/json;charset=utf-8',

                    },
                    body: `{ \"messaging_product\": \"whatsapp\", \"to\": \"1${d.telefono}\", \"type\": \"template\", \"template\": { \"name\": \"plantilla_prueba_alex\", \"language\": { \"code\": \"es\" } } }`
                }

                )
                obtenerDatosCitas();
                            Swal.fire(
                                'Enviado!',
                                'El Mensaje se ha enviado al '+d.telefono,
                                'success'
                            )
                        
                  
            }
        })

     
    }



    const NuevaCita = () => {
        obtenerespecialista();
        obtenerProductos()
        obtenerDatosDoctor()
    }

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar.  Favor validar si la informacion esta bien o el horario de la cita esta ocupado. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }

    useEffect(() => {


        const intervalo = setInterval(() => {
            buildCalendar(currentMonth)
        }, 3000); // 3000 ms = 3 segundos

        return () => clearInterval(intervalo); // Limpieza
    }, []);
    //// Guardar//////
    const guardarCambios = async () => {
        let response;
        tabla.tratamientoID = parseInt(tabla.tratamientoID);
        tabla.sucursalID = parseInt(tabla.sucursalID);
        if (tabla.notificacionWhatsapp == 'false' || tabla.notificacionWhatsapp == false) { tabla.notificacionWhatsapp = Boolean(0) } else { tabla.notificacionWhatsapp = Boolean(1) }
        if (tabla.confirmacionCita == 'false' || tabla.confirmacionCita == false) { tabla.confirmacionCita = Boolean(0) } else { tabla.confirmacionCita = Boolean(1) }
        if (tabla.notificacionCorreo == 'false' || tabla.notificacionCorreo == false) { tabla.notificacionCorreo = Boolean(0) } else { tabla.notificacionCorreo = Boolean(1) }
        tabla.fecha = moment(tabla.fecha).format("YYYY-MM-DD")
        if (tabla.citaID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Citas/GuardarCitas", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
          
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Citas/EditarCitas", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            Swal.fire(
                'Se Guardo!',
                'La Cita ha sido Guardad.',
                'success'
            )
            obtenerDatosCitas(FechaControl);
                setTabla(modeloDatos);
            setVerModalCita(!verModalCita);
            
           
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
               
                setTabla(modeloDatos)
                setVerModalCita(!verModalCita);
            }
        } else {
            mostrarMensaje()
            
        }
        
    }

    // Manejar ventanas modales////////
    const CitaNuevaVieja = (data) => {

       

        obtenerespecialista();
        obtenerProductos();
        tabla.telefono = data.telefono;
        tabla.cedula = data.cedula;
        tabla.nombrePaciente = data.nombrePaciente;
        tabla.edad = data.edad;
        tabla.seguroID = data.seguroID;
        tabla.especialistaID = data.especialistaID;
        tabla.tratamientoID = data.tratamientoID;
        setVerModalCita(!verModalCita);
    }

    const abrirEditarModal = (data, v) => {

        if (v == 1) {
           setVisualizar(!Visualizar);
        }
        setVisualizarC(true)
        obtenerespecialista();
        obtenerProductos();
        setTabla(data);
        setVerModalCita(!verModalCita);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModalCita(false)
        setVisualizar(false)
        setVisualizarC(false)
    }
    const EliminarCita = async (x) => {
        Swal.fire({
            title: 'Eliminar',
            text: "Estas seguro de eliminar la cita de"+x.nombrePaciente+". ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {
                let response =  fetch(Api + "Citas/EliminarCita/" + x.citaID + "/" + correo);

                if (response.ok) {
                    obtenerDatosCitas();
                    toast.success("Proceso realizado")

                }

            }
        })

    }
    ///FACTURAR DESDE CITA
    const facturarcita = (data, v) => {
        setVerFactura(true);
        setTabla(data);
        let response = fetch(Api + "Citas/Facturado/" + data.citaID, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(tabla)
        })
        obtenerDatosCitas(FechaControl)
    }

    const obtenerDatosSeguro = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/" + JSON.parse(user).correo + "/1");


        if (response.ok) {
            let data = await response.json()
            data.map(x => {
                optionsSeguro.push({ value: x.seguroID, label: x.descripcion, nombre: x.descripcion, tab: 'Seguro' })
            })
        }
    }

    const columnsCitas = [

        {
            name: 'Paciente',
            selector: row => (<><div hidden={!row.confirmacionCita} style={{ background: "#c1ebc6", color: "black", width: "100%", padding:"10px" }}>
                {row.nombrePaciente}</div>
                <div hidden={row.confirmacionCita}>{row.nombrePaciente}{row.confirmacionCita}</div>
          
            </>),
            sortable: true,
            width: window.innerWidth < 768 ? '30%':'25%',
            style: row => (row.confirmacionCita &&{
                background: '#c1ebc6'
            }),
        },
        {
            name: 'Telefono',
            selector: row => row.telefono ,
            sortable: true,
            width: '15%',
            // Ocultar en móviles
            omit: window.innerWidth < 768
        }, {
            name: 'Fecha',
            selector: row => (moment(row.fecha).format("DD/MM/YYYY")),
            sortable: true,
            width: '15%',
            // Ocultar en móviles
            omit: window.innerWidth < 768
        },{
            name: 'Hora',
            selector: row => row.hora,
            sortable: true,
            width: window.innerWidth < 768 ? '20%': '12%',
        },
        //{
        //    name: 'Doctor',
        //    selector: row => (ListaDoctores.length < 1) ? ("N/A"): ( ListaDoctores.find(x => x.doctorID === row.especialistaID).nombreDoctor ) ,
        //    sortable: true,
        //    width: '12%',
        //    // Ocultar en móviles
        //    omit: window.innerWidth < 768
        //},
//        {
//            name: 'Envio W',
//            selector: row => (<span className="">{row.notificacionWhatsapp ? "Si" : "No"}</span>
//),
//            sortable: true,
//            width: '10%',

        //        },
        {
            name: 'Confirmacion',
            selector: row => (<><input type="checkbox" onClick={() => ConfirmarCita(row)}  checked={row.confirmacionCita}></input></>),
            sortable: true,
            width: window.innerWidth < 768 ? '12%' : '10%',

        },
                
                    
        {
            width: window.innerWidth < 768 ? '10%' : '12%',
            name: '',
            cell: row => (
                <>
                    
                    <Button color="success" size="sm" className="mr-2"
                        href={"https://wa.me/1" + row.telefono + "?text=Buenos días, le recordamos su cita el " + (moment(row.fecha).format("DD/MM/YYYY"))+
                            " a las " + row.hora +" con "+     (ListaDoctores.find(x => x.doctorID === row.especialistaID)?.nombreDoctor)
                        + ", favor confirmar su asistencia!."} target="_blank"
                        onClick={() => RecordatorioWhatsapp(row.citaID)} title="Enviar Whatsapp"
                    >
                        <i className="">W</i>
                    </Button>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
             <Button color="danger" size="sm" className="mr-2"
                        onClick={() => EliminarCita(row)}
                    >
                        <i className="fas fa-trash"></i>
                    </Button>
          
                </>
            ),
        },
    ];

    //Diseño tabla
    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
                paddingRight: '1px',
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
                minHeight: '30px',
            }
        }
    };


    // Ejemplo de validaciones rápidas:
    const isTelefonoInvalid = (t) => !t || String(t).length !== 10;

    const [fecha, setFecha] = useState(null);

    // función que filtra solo lunes (1) y miércoles (3)
    const filtrarLunesMiercoles = (date) => {
        const dia = date.getDay(); // 0=Domingo, 1=Lunes, 2=Martes, 3=Miércoles, ...
        if (tabla.sucursalID == 1) {
            return dia === 1 || dia === 2 || dia === 3;
        } else {
            return dia === 4 || dia === 5;
        }
    };


    function formatKey(date) {
        return date.toISOString().split("T")[0]; // 2025-12-05
    }

    function isSameDay(a, b) {
        return formatKey(a) === formatKey(b);
    }

    function buildCalendar(currentMonth) {
        const year = currentMonth.getFullYear();
        const month = currentMonth.getMonth();
        const firstDay = new Date(year, month, 1);
        const startingWeekDay = firstDay.getDay(); // 0 = domingo
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        const cells = [];
        // huecos antes del 1
        for (let i = 0; i < startingWeekDay; i++) {
            cells.push(null);
        }
        // días reales del mes
        for (let d = 1; d <= daysInMonth; d++) {
            cells.push(new Date(year, month, d));
        }
        // completar hasta múltiplo de 7
        while (cells.length % 7 !== 0) {
            cells.push(null);
        }
        return cells;
    }


    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(null);
    const [showForm, setShowForm] = useState(false);

    const [form, setForm] = useState({
        paciente: "",
        hora: "",
        nota: "",
    });

    const [citas, setCitas1] = useState([]); // {id, dateKey, paciente, hora, nota}

    const cells = buildCalendar(currentMonth);

    const handlePrevMonth = () => {
        setCurrentMonth(
            new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth() - 1,
                1
            )
        );
    };

    const handleNextMonth = () => {
        setCurrentMonth(
            new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth() + 1,
                1
            )
        );
    };

    const handleDayClick = (day) => {
        if (!day) return;
        setSelectedDate(day);
        NuevaCita()
        //  setShowForm(true);
        tabla.fecha = day
        setVerModalCita(!verModalCita)
    };

    const handleChangeForm = (e) => {
        const { name, value } = e.target;
        setForm((f) => ({ ...f, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedDate) return;

        const dateKey = formatKey(selectedDate);

        setCitas1((prev) => [
            ...prev,
            {
                id: crypto.randomUUID(),
                dateKey,
                paciente: form.paciente,
                hora: form.hora,
                nota: form.nota,
            },
        ]);

        // limpiar y cerrar
        setForm({ paciente: "", hora: "", nota: "" });
        setShowForm(false);
    };

    const countCitas = (day) => {
        if (!day) return 0;
        const key = formatKey(day);
        return Listado.filter((c) => moment(c.fecha).format("YYYY-MM-DD") === key).length;
        // return citas.filter((c) => c.dateKey === key).length;
    };

    const citasDelDia = selectedDate
        ? citas.filter((c) => c.dateKey === formatKey(selectedDate))
        : [];

    const monthLabel = currentMonth.toLocaleString("es-ES", {
        month: "long",
        year: "numeric",
    });

    return (
        <>
        <Row>
            <Col md={6}>
            <div className="calendar-wrapper" style={{ color: "#000" }}>
                <div className="calendar-header">
                    <button onClick={handlePrevMonth} >{"<"}</button>
                    <h3 style={{ textTransform: "uppercase" }}>{monthLabel}</h3>
                    <button onClick={handleNextMonth}>{">"}</button>
                </div>

                <div className="calendar-weekdays">
                    {["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"].map((d) => (
                        <div key={d} className="weekday">
                            {d}
                        </div>
                    ))}
                </div>

                <div className="calendar-grid" style={{ color: "#000" }}>
                    {cells.map((day, idx) => {
                        const numCitas = day ? countCitas(day) : 0;
                        //const numCitas = day ? countCitas(day) : 0;
                        return (
                            <button
                                key={idx}
                                className={`calendar-day ${day ? "" : "empty"}`}
                                onClick={() => handleDayClick(day)}
                                disabled={!day}

                            >
                                {day && (
                                    <>
                                        <span className="day-number" style={{ color: "#000" }}>{day.getDate()}</span>
                                        {numCitas > 0 && (
                                            <div className="citas-chip">
                                                <span>{numCitas}{day.cantidadCitas}</span>
                                                <small>citas</small>
                                            </div>
                                        )}
                                    </>
                                )}
                            </button>
                        );
                    })}
                </div>

                {/* Modal / formulario */}
                {showForm && (
                    <div className="modal-backdrop">
                        <div className="modal-box">
                            <h3>
                                Nueva cita –{" "}
                                {selectedDate &&
                                    selectedDate.toLocaleDateString("es-ES")}
                            </h3>

                            {citasDelDia.length > 0 && (
                                <div className="citas-list">
                                    <strong>Citas existentes:</strong>
                                    <ul>
                                        {citasDelDia.map((c) => (
                                            <li key={c.id}>
                                                {c.hora} - {c.paciente} ({c.nota})
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            <form onSubmit={handleSubmit} className="form-cita">
                                <label>
                                    Paciente
                                    <input
                                        name="paciente"
                                        value={form.paciente}
                                        onChange={handleChangeForm}
                                        required
                                    />
                                </label>
                                <label>
                                    Hora
                                    <input
                                        type="time"
                                        name="hora"
                                        value={form.hora}
                                        onChange={handleChangeForm}
                                        required
                                    />
                                </label>
                                <label>
                                    Nota
                                    <textarea
                                        name="nota"
                                        value={form.nota}
                                        onChange={handleChangeForm}
                                    />
                                </label>

                                <div className="modal-actions">
                                    <button type="button" onClick={() => setShowForm(false)}>
                                        Cancelar
                                    </button>
                                    <button type="submit">Guardar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
            </Col>
            <Col md={6}>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            Lista de Citas del 

                            <FormGroup>
                     
                                <DatePicker
                                    className="form-control form-control-sm"
                                    selected={FechaControl}
                                    onChange={(date) => Cam_F(date)}
                                    dateFormat='dd/MM/yyyy'
                                />
                            </FormGroup>
                    <a className="btn" color="primary"
                        onClick={() => Setinterativo(true)} >
                        <i >Guia</i>
                            </a>

                </CardHeader>
                <CardBody hidden>

                  {/*  Ventana de seleccion y envio Whatsapp Y manejo Fechas*/}
                    <Row className="align-items-end">
                    <Col sm={3} hidden>
                        <FormGroup>
                    <Button color="success" size="sm"
                        onClick={() => NuevaCita() }
                            >Registrar Nueva Cita</Button>

                        </FormGroup>
                    </Col>

                        <Col sm={6}>

                           {/* Campo de fecha*/}
                        <FormGroup>
                           Fecha de Citas:
                            <DatePicker
                                className="form-control form-control-sm"
                                    selected={FechaControl}
                                onChange={(date) => Cam_F(date)}
                                dateFormat='dd/MM/yyyy'
                            />
                        </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Button color="success" size="sm"
                                    onClick={() => SetHistorialCita(true)}
                                >Citas Anteriores</Button>

                            </FormGroup>
                        </Col>

                        {/*<Col sm={3}>*/}
                        {/*    <FormGroup>*/}
                        {/*        <Button color="success" size="sm"*/}
                        {/*            onClick={() => EnviarWhatsAppM()}*/}
                        {/*        >*/}
                        {/*            Whatsapp Masivo</Button>*/}

                        {/*    </FormGroup>*/}
                        {/*</Col>*/}

                    {/*Fecha: <Input bsSize="sm" type="date" name="fecha" onChange={handleChange} value={Moment(new Date).format('YYYY-MM-DD')} />*/}
                    </Row>
                
                </CardBody>

                <DataTable
                    columns={columnsCitas}
                    data={ListadoCitas}

                                 customStyles={customStyles}
                 
                />
         
        
        </Card >
                </Col>
            </Row>


            <Modal isOpen={verModalCita} className="modal-preguntas">
                <ModalHeader className="modal-header1" >
        
                    <div class="box">
                        <div>    Mantenimiento de Citas  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
           

                    <Row className="g-3">
                        {/* Panel izquierdo */}
                        <Col md="6">
                            <Card className="citas-card">
                                <div class="bg-gradient-to-r from-blue-50 to-indigo-50 p-2 rounded-lg ">
                                    <h2 class="text-sm font-bold text-gray-700 flex items-center">
                                        <svg class="w-4 h-4 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                                        </svg>
                                        Información del Paciente
                                    </h2>
                                </div>
                                <CardBody className="p-2">
                                    {/* Teléfono */}
                              
                                    <FormGroup className="mb-3">
                                        <Label className="citas-label">
                                        
                                            <i className="fas fa-phone-alt me-2" style={{ color: "#3e80bd" }} /> Teléfono del Paciente
                                        </Label>
                                        <Input
                                            disabled={Visualizar}
                                            bsSize="sm"
                                            type="text"
                                            name="telefono"
                                            maxlength="22"

                                            value={tabla.telefono}
                                            onChange={handleChange}
                                            invalid={isTelefonoInvalid(tabla.telefono)}
                                            placeholder="Teléfono"
                                        />
                                                 </FormGroup>
                                  
                                    {/* Nombre */}
                                    <FormGroup className="mb-3">
                                        <Label className="citas-label">
                                            <i className="fas fa-user me-2" style={{ color: "#3e80bd" }} /> Nombre del Paciente
                                        </Label>
                                        <Input
                                            disabled={Visualizar}
                                            bsSize="sm"
                                            name="nombrePaciente"
                                            value={tabla.nombrePaciente}
                                            onChange={handleChange}
                                            placeholder="Nombre del Paciente"
                                        />
                                    </FormGroup>

                                    {/* Edad */}
                                    <FormGroup className="mb-3 position-relative">
                                        <Label className="citas-label">
                                            <i className="fas fa-birthday-cake me-2" style={{ color: "#3e80bd" }} /> Edad del Paciente
                                        </Label>
                                        <Input
                                            disabled={Visualizar}
                                            bsSize="sm"
                                            name="edad"
                                            value={tabla.edad}
                                            onChange={handleChange}
                                            placeholder="Edad"
                                        />         {/*invalid={isEdadInvalid(tabla.edad)}*/}
                                        {/*{isEdadInvalid(tabla.edad) ? (*/}
                                        {/*    <div className="invalid-hint">Proporcione una edad válida</div>*/}
                                        {/*) : null}*/}
                                        {/* Icono “ayuda” a la derecha (decorativo) */}
                                      
                                    </FormGroup>
                                    {/* Nombre */}
                                    <FormGroup className="mb-3">
                                        <Label className="citas-label">
                                            <i className="fas fa-user me-2" style={{ color: "#3e80bd" }} /> País
                                        </Label>

                                        <Input
                                            type="select"
                                            disabled={Visualizar}
                                            bsSize="sm"
                                            name="domicilio"
                                            value={tabla.domicilio}
                                            onChange={handleChange}
                                        >
                                            <option value="">Seleccione un país</option>
                                            {[
                                                "Afganistán", "Albania", "Alemania", "Andorra", "Angola", "Antigua y Barbuda",
                                                "Arabia Saudita", "Argelia", "Argentina", "Armenia", "Australia", "Austria",
                                                "Azerbaiyán", "Bahamas", "Bangladés", "Barbados", "Baréin", "Bélgica",
                                                "Belice", "Benín", "Bielorrusia", "Birmania", "Bolivia", "Bosnia y Herzegovina",
                                                "Botsuana", "Brasil", "Brunéi", "Bulgaria", "Burkina Faso", "Burundi",
                                                "Cabo Verde", "Camboya", "Camerún", "Canadá", "Catar", "Chad",
                                                "Chile", "China", "Chipre", "Colombia", "Comoras", "Corea del Norte",
                                                "Corea del Sur", "Costa de Marfil", "Costa Rica", "Croacia", "Cuba",
                                                "Dinamarca", "Dominica", "Ecuador", "Egipto", "El Salvador",
                                                "Emiratos Árabes Unidos", "Eritrea", "Eslovaquia", "Eslovenia", "España",
                                                "Estados Unidos", "Estonia", "Eswatini", "Etiopía", "Filipinas", "Finlandia",
                                                "Fiyi", "Francia", "Gabón", "Gambia", "Georgia", "Ghana", "Granada",
                                                "Grecia", "Guatemala", "Guinea", "Guinea-Bisáu", "Guinea Ecuatorial",
                                                "Guyana", "Haití", "Honduras", "Hungría", "India", "Indonesia",
                                                "Irak", "Irán", "Irlanda", "Islandia", "Islas Cook", "Islas Marshall",
                                                "Islas Salomón", "Israel", "Italia", "Jamaica", "Japón", "Jordania",
                                                "Kazajistán", "Kenia", "Kirguistán", "Kiribati", "Kuwait", "Laos",
                                                "Lesoto", "Letonia", "Líbano", "Liberia", "Libia", "Liechtenstein",
                                                "Lituania", "Luxemburgo", "Madagascar", "Malasia", "Malaui", "Maldivas",
                                                "Malí", "Malta", "Marruecos", "Mauricio", "Mauritania", "México",
                                                "Micronesia", "Moldavia", "Mónaco", "Mongolia", "Montenegro",
                                                "Mozambique", "Namibia", "Nauru", "Nepal", "Nicaragua", "Níger",
                                                "Nigeria", "Noruega", "Nueva Zelanda", "Omán", "Países Bajos",
                                                "Pakistán", "Palaos", "Panamá", "Papúa Nueva Guinea", "Paraguay",
                                                "Perú", "Polonia", "Portugal", "Reino Unido", "República Centroafricana",
                                                "República Checa", "República Dominicana", "Ruanda", "Rumanía",
                                                "Rusia", "Samoa", "San Cristóbal y Nieves", "San Marino",
                                                "San Vicente y las Granadinas", "Santa Lucía", "Santo Tomé y Príncipe",
                                                "Senegal", "Serbia", "Seychelles", "Sierra Leona", "Singapur",
                                                "Siria", "Somalia", "Sri Lanka", "Sudáfrica", "Sudán", "Sudán del Sur",
                                                "Suecia", "Suiza", "Surinam", "Tailandia", "Tanzania", "Tayikistán",
                                                "Timor Oriental", "Togo", "Tonga", "Trinidad y Tobago", "Túnez",
                                                "Turkmenistán", "Turquía", "Tuvalu", "Ucrania", "Uganda",
                                                "Uruguay", "Uzbekistán", "Vanuatu", "Vaticano", "Venezuela",
                                                "Vietnam", "Yemen", "Yibuti", "Zambia", "Zimbabue"
                                            ].map((pais) => (
                                                <option key={pais} value={pais}>{pais}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>


                                    {/* Comentario */}
                                    <FormGroup className="mb-0">
                                        <Label className="citas-label">
                                            <i className="fas fa-comment-dots me-2" style={{ color: "#3e80bd" }} /> Motivo de Consulta / Comentario
                                        </Label>
                                        <Input
                                            disabled={Visualizar}
                                            bsSize="sm"
                                            type="textarea"
                                            rows={2.5}
                                            name="comentario"
                                            value={tabla.comentario}
                                            onChange={handleChange}
                                            placeholder="Escriba el motivo de la consulta"
                                        />
                                    </FormGroup>
                                </CardBody>
                            </Card>
                        </Col>

                        {/* Panel derecho */}
                        <Col md="6">
                            <Card className="citas-card">
                                 <div class="bg-gradient-to-r from-indigo-50 to-purple-50 p-2 rounded-lg ">
                                        <h2 class="text-sm font-bold text-gray-700 flex items-center">
                                            <svg class="w-4 h-4 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                                            </svg>
                                            Detalles de la Cita
                                        </h2>
                                    </div>  <CardBody className="p-2">
                                    {/* Servicio */}
                                 
                                    <FormGroup className="mb-3">
                                        <Label className="citas-label">
                                            <i className="fas fa-stethoscope me-2" style={{ color: "#3e80bd" }} /> Servicio 
                                        </Label>
                                    
                                        <Select
                                            name="tratamientoID"
                                            onChange={handleChange2}
                                            value={optionsArticulos.find((x) => x.value === tabla.tratamientoID) || null}
                                            options={optionsArticulos}
                                            classNamePrefix="react-select"
                                            isDisabled={Visualizar}
                                            placeholder="Seleccione el Servicio" />
                                    </FormGroup>

                                    {/* Especialista */}
                                    <FormGroup className="mb-3">
                                        <Label className="citas-label">
                                            <i className="fas fa-user-md me-2" style={{ color: "#3e80bd" }} /> Médico / Especialista Asignado
                                        </Label>
                                        <Select
                                                name="doctorID"
                                                onChange={handleChange2}
                                                value={optionsDoctores.find((x) => x.value === tabla.especialistaID) || null}
                                            options={optionsDoctores}
                                                classNamePrefix="react-select"
                                                isDisabled={Visualizar}
                                                placeholder="Seleccione el Especialista"  />
                                    </FormGroup>

                                    {/* Seguro */}
                                    <FormGroup className="mb-3">
                                        <Label className="citas-label">
                                            <i className="fas fa-id-card me-2" style={{ color: "#3e80bd" }} /> Tipo de Seguro Médico
                                        </Label>
                                        {rol == 3 ? (
                                            <Input
                                                disabled
                                                bsSize="sm"
                                                value={optionsSeguro.find((o) => o.value === tabla.seguroID)?.label || "Privado"}
                                            />
                                        ) : (
                                            <Select
                                                name="seguroID"
                                                onChange={handleChange2}
                                                value={optionsSeguro.find((x) => x.value === tabla.seguroID) || null}
                                                options={optionsSeguro}
                                                classNamePrefix="react-select"
                                                isDisabled={Visualizar}
                                                placeholder="Seleccione el seguro"
                                            />
                                        )}
                                    </FormGroup>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label className="citas-label"><i class="fas fa-location" style={{ color: "#3e80bd" }}></i>Sucursal</Label>
                                            <Input

                                                bsSize="sm"
                                                type="select"
                                                name="sucursalID"
                                                value={tabla.sucursalID}
                                                onChange={handleChange}
                                            >
                                                <option value={1}>LA VEGA</option>
                                                <option value={2}>SANTO DOMINGO</option>
                                                {/*{ListadoSucursal.map(x => (<option value={x.sucursalID}>{x.descripcion}</option>))}*/}

                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    {/* Fecha */}
                                        <FormGroup className="mb-2">
                                        <div class="box">
                                            <div >
                                        <Label className="citas-label">
                                                    <i className="fas fa-calendar-day me-2" style={{ color: "#3e80bd" }} /> Fecha de la Cita
                                                </Label>
                                                <DatePicker
                                                    selected={new Date(tabla.fecha)}
                                                    onChange={handleChangef}
                                                    dateFormat="dd/MM/yyyy"
                                                    filterDate={filtrarLunesMiercoles}
                                                    placeholderText="Elige una fecha válida"
                                                    locale="es"
                                                    isClearable
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    minDate={new Date()}
                                                />
                                        {/*<DatePicker*/}
                                        {/*    className="form-control form-control-sm"*/}
                                        {/*    selected={new Date(tabla.fecha)}*/}
                                        {/*    onChange={handleChangef}*/}
                                        {/*    dateFormat="dd/MM/yyyy"*/}
                                        {/*    minDate={new Date()}*/}
                                        {/*    disabled={Visualizar}*/}
                                        {/*/>*/}
                                            </div>
                                   <div Col="5">
                                        <Label className="citas-label">
                                                    <i className="far fa-clock me-2" style={{ color: "#3e80bd" }} /> Hora de la Cita
                                                </Label>
                                              
                                        <Input
                                            className="form-control"
                                            disabled={Visualizar}
                                            bsSize="sm"
                                            type="select"
                                            name="hora"
                                            value={tabla.hora}
                                            onChange={handleChange}
                                        >
                                          
                                            {ListaHorario.map((x) => (
                                                <option key={x.horarioID} value={x.hora}>
                                                    {x.hora}
                                                </option>
                                            ))}
                                                    </Input> </div></div>
                                    </FormGroup>
                                   
                              
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* Opciones de notificación (ocultas opcionalmente) */}
                    {VisualizarC && (
                        <Row className="g-3 mt-1">
                            <Col md="4">
                                <FormGroup>
                                    <Label className="citas-label">Confirmación Cita</Label>
                                    <Input
                                        disabled={Visualizar}
                                        bsSize="sm"
                                        type="select"
                                        name="confirmacionCita"
                                        value={tabla.confirmacionCita}
                                        onChange={handleChange}
                                    >
                                        <option value={true}>Sí</option>
                                        <option value={false}>No</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="citas-label">Notificación Correo</Label>
                                    <Input
                                        disabled={Visualizar}
                                        bsSize="sm"
                                        type="select"
                                        name="notificacionCorreo"
                                        value={tabla.notificacionCorreo}
                                        onChange={handleChange}
                                    >
                                        <option value={true}>Sí</option>
                                        <option value={false}>No</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="citas-label">Notif. Whatsapp</Label>
                                    <Input
                                        disabled={Visualizar}
                                        bsSize="sm"
                                        type="select"
                                        name="notificacionWhatsapp"
                                        value={tabla.notificacionWhatsapp}
                                        onChange={handleChange}
                                    >
                                        <option value={true}>Sí</option>
                                        <option value={false}>No</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                    )}

                    {/* Botonera */}
                    <div className="d-flex justify-content-end gap-2 mt-3">
                        <Button color="light" className="btn-cancelar" onClick={cerrarModal}>
                            Cancelar
                        </Button>
                        <Button color="primary" className="btn-agendar" onClick={guardarCambios}>
                            Agendar cita
                        </Button>
                    </div>
                </ModalBody>
               
            </Modal>

            {/*VENTA*/}
            <Modal className="modal-preguntas" isOpen={VerFactura}>
                <ModalHeader className="modal-header1">
                    FACTURACION.
                    <Button size="sm" color="danger"
                        onClick={() => setVerFactura(false)}
                    >Cerrar</Button>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Venta key={key} data={[tabla]} onData={apagarcomponente } />
                    </Row>
                </ModalBody>

            </Modal>

            <Modal className="modal-preguntas" isOpen={HistorialCita}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>    Historial de Citas. </div>
                        <div> <a className="btn" style={{ color: "#ffff" }} onClick={()=>SetHistorialCita(false)}>X</a> </div>
                    </div>     
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={4}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)}
                            placeholder="Buscar  por nombre / telefono" ></Input> </Col>

                        <table>
                            <tr>
                            <th>Nombre</th>
                            <th>Telefono</th>
                            <th>Hora</th>
                            <th>Fecha</th>
                            <th>Agendar una cita nueva</th>
                            </tr>
                            {Listado.map(x => (
                                <tr>
                                    <td>{x.nombrePaciente} </td>
                                    <td>{x.telefono} </td>
                                    <td>{x.hora} </td>
                                    <td>{moment(x.fecha).format("DD/MM/YYYY")} </td>
                                    <td><Button size="sm" color="success"
                                        onClick={() => CitaNuevaVieja(x)}
                                    >Nueva Cita</Button> </td>

                                </tr>
                            ))}
                        </table>

                        <FormGroup>
                          
                            <Button size="sm" color="danger"
                                onClick={() => SetHistorialCita(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>

            {/*AYUDA TUTORIAL*/}
            <Modal className="modal-preguntas" isOpen={interativo}>
                <ModalHeader className="modal-header1">
                    Manuales interativo.
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {/*<a href="\imagen\Manual de usuario Sistema Evaluación de Desempeño ETED.pdf" target="_blank" >Descargar Manual PDF</a>*/}
                            <video width="100%" height="70%" controls>
                                <source src="\imagen\Citas.mp4" type="video/mp4" />
                            </video>

                            <Button size="sm" color="danger"
                                onClick={() => Setinterativo(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>


        </>
    )

}
export default Version;